import { z } from 'zod'
import { oc } from '@orpc/contract'

// Booleans only, never values — this surface (member-editable, not just super admin) must
// never echo back a Stripe/Bridge secret it was given. Same convention as the super-admin
// organization-bridge-key / organization-stripe-keys status endpoints.
export const billingSettingsStatusOutput = z.object({
  stripe: z.object({
    publishableKeyConfigured: z.boolean(),
    secretKeyConfigured: z.boolean(),
    webhookSecretConfigured: z.boolean(),
  }),
  bridge: z.object({
    apiKeyConfigured: z.boolean(),
    webhookSecretConfigured: z.boolean(),
  }),
  stedi: z.object({
    apiKeyConfigured: z.boolean(),
  }),
})

export const billingSettingsStatus = oc
  .route({ method: 'GET', path: '/v2/billing/settings/{organizationId}/status' })
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(billingSettingsStatusOutput)

export const billingSettingsUpdate = oc
  .route({ method: 'POST', path: '/v2/billing/settings/{organizationId}' })
  .input(
    z.object({
      organizationId: z.string().min(1),
      // Every field optional and write-only: only what's given is written, nothing is
      // ever read back through this endpoint (the output is fresh status booleans, not
      // an echo of what was just saved). Stripe's webhookSecret is deliberately NOT an
      // input field here — same as the super-admin flow, saving the key pair validates
      // it against Stripe and auto-registers the co-pay webhook server-side
      // (applyOrganizationStripeKeys); it is never hand-entered.
      stripe: z
        .object({
          publishableKey: z.string().trim().min(1),
          secretKey: z.string().trim().min(1),
        })
        .optional(),
      bridge: z
        .object({
          apiKey: z.string().trim().min(1).optional(),
          webhookSecret: z.string().trim().min(1).optional(),
        })
        .optional(),
      stedi: z
        .object({
          apiKey: z.string().trim().min(1).optional(),
        })
        .optional(),
    }),
  )
  .output(billingSettingsStatusOutput)
